import moment from "moment";
import { useEffect } from "react";
import { useFormState, useForm } from "react-final-form";

import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";

import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import BMXDatePicker from "../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";

import BMXUserView from "../../../../../Components/BMXUserView/BMXUserView";
import BMXAutocomplente from "../../../../../Components/Inputs/BMXAutocomplete/BMXAutocomplete";
import BMXTimePicker from "../../../../../Components/Inputs/BMXTimePicker/BMXTimePicker";

const ProjectSubtaskModalFormStepOne = ({ workers, ...props }) => {
  const { t } = useTranslation();
  const form = useForm();
  const formState = useFormState();

  const {
    subtaskStartDate,
    subtaskStartTime,
    subtaskEndDate,
    subtaskEndDateTime,
    subtaskDeadline,
    subtaskDeadlineTime,
  } = formState.values;

  const syncDateTime = (date, time, fieldName) => {
    if (date && time) {
      const dateMoment = moment(date);
      const timeMoment = moment(time);

      dateMoment.hour(timeMoment.hour());
      dateMoment.minute(timeMoment.minute());
      dateMoment.second(0);
      dateMoment.millisecond(0);

      if (!moment(date).isSame(dateMoment)) {
        form.change(fieldName, dateMoment.toDate());
      }
    }
  };

  useEffect(() => {
    // Start time
    if (subtaskStartDate && !subtaskStartTime) {
      const time = moment(subtaskStartDate).toDate();
      form.change("subtaskStartTime", time);
    }
    // End time
    if (subtaskEndDate && !subtaskEndDateTime) {
      const time = moment(subtaskEndDate).toDate();
      form.change("subtaskEndDateTime", time);
    }
    // Deadline time
    if (subtaskDeadline && !subtaskDeadlineTime) {
      const time = moment(subtaskDeadline).toDate();
      form.change("subtaskDeadlineTime", time);
    }
  }, [
    subtaskStartDate,
    subtaskStartTime,
    subtaskEndDate,
    subtaskEndDateTime,
    subtaskDeadline,
    subtaskDeadlineTime,
    form,
  ]);

  // Synchronizacja pól dat z czasem po każdej zmianie
  useEffect(() => {
    syncDateTime(subtaskStartDate, subtaskStartTime, "subtaskStartDate");
  }, [subtaskStartDate, subtaskStartTime]);

  useEffect(() => {
    syncDateTime(subtaskEndDate, subtaskEndDateTime, "subtaskEndDate");
  }, [subtaskEndDate, subtaskEndDateTime]);

  useEffect(() => {
    syncDateTime(subtaskDeadline, subtaskDeadlineTime, "subtaskDeadline");
  }, [subtaskDeadline, subtaskDeadlineTime]);

  return (
    <div className="AddProjectStepOne" style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:project.basicSubtaskInformation")} />

      <Row>
        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={t("global:project.subtaskContent")}
            name="subtaskContent"
            multiline
            maxRows={4}
            data-cy="subtaskContent"
          />
        </Col>
      </Row>

      <Row>
        <Col xs={6}>
          <Field
            component={BMXAutocomplente}
            options={workers}
            data-cy="subtaskAssignee"
            currentValues={props.values}
            label={t("global:project.subtaskAssignee")}
            limitTags={1}
            multiple
            name="subtaskAssignee"
            renderOption={(props, option) => (
              <li key={option.uuid} {...props}>
                <BMXUserView color="primary" user={option}></BMXUserView>
              </li>
            )}
            getOptionLabel={(option) =>
              `${option.lastName} ${option.firstName} ${option.firstName} ${option.lastName}`
            }
            renderTags={(values) =>
              values.map((option, index) => (
                <BMXUserView
                  comma={values.length - 1 !== index}
                  key={option.uuid}
                  color="primary"
                  user={option}
                />
              ))
            }
          />
        </Col>
      </Row>

      {/* START DATE + TIME */}
      <Row className="mt-3">
        <Col xs={3}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:project.subtaskStartDate")}*`}
            name="subtaskStartDate"
            data-cy="subtaskStartDate"
          />
        </Col>
        <Col xs={3}>
          <Field
            name="subtaskStartTime"
            component={BMXTimePicker}
            label={t("global:project.subtaskStartDateTime")}
          />
        </Col>

        {/* END DATE + TIME */}
        <Col xs={3}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:project.subtaskEndDate")}*`}
            name="subtaskEndDate"
            data-cy="subtaskEndDate"
          />
        </Col>
        <Col xs={3}>
          <Field
            name="subtaskEndDateTime"
            component={BMXTimePicker}
            label={t("global:project.subtaskEndDateTime")}
          />
        </Col>
      </Row>

      {/* DEADLINE + TIME */}
      <Row className="mt-3">
        <Col xs={3}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:project.subtaskDeadline")}*`}
            name="subtaskDeadline"
            data-cy="subtaskDeadline"
          />
        </Col>
        <Col xs={3}>
          <Field
            name="subtaskDeadlineTime"
            component={BMXTimePicker}
            label={t("global:project.subtaskDeadlineTime")}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ProjectSubtaskModalFormStepOne;
